export default __webpack_public_path__ + "media/plus/plus-extra-security-ee22e769.jpg";